import 'babel-polyfill'
import 'fix-date'
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'

import 'srcReact/assets/scss/index.scss'
import { I18nextProvider } from 'react-i18next'
import i18n from 'i18next'
import store from 'srcReact/helpers/store'
import { App } from 'srcReact/App'
import config from 'config'

import common from '!json-loader!./translations/en/common.json'
import commonFr from '!json-loader!./translations/fr/commonFr.json'
import 'reactjs-popup/dist/index.css'
import '!style-loader!css-loader!react-big-calendar/lib/css/react-big-calendar.css'
import LanguageDetector from 'i18next-browser-languagedetector'
import { appConstantSettings } from './appConstantSettings'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'

window.config = config

i18n.use(LanguageDetector).init({
  debug: true,
  interpolation: { escapeValue: false },
  fallbackLng: appConstantSettings.DEFAULT_LANGUAGE,
  defaultNS: 'common',
  ns: ['common'],
  resources: {
    en: {
      common: common
    },
    fr: {
      common: commonFr
    }
  },
  detection: {
    order: isUserAuthorized() ? ['cookie'] : config.enableTranslation ? ['navigator', 'cookie'] : ['cookie'],
    caches: ['cookie'],
    lookupCookie: appConstantSettings.LANG_COOKIE_NAME,
    cookieMinutes: 525600 //365 days
  }
})

render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <App />
    </Provider>
  </I18nextProvider>,
  document.getElementById('app')
)
